import { createContext } from 'react'
import DebugOptions from './DebugOptions'

const DebugOptionsContext = createContext<DebugOptions>({
  jsonIncludeChildren: false,
})

export default DebugOptionsContext
